@Service('ib-header-main-page-component-module', ['localStorageService', 'ibHeaderMainPageConstants', '$rootScope', '$filter', 'CommonsUserUtilsService'])
class ibHeaderMainPageServiceModel {
    private viewInfo: ibHeaderMainPage.MainInfo;
    constructor (
        private localStorageService: angular.local.storage.ILocalStorageService,
        private ibHeaderMainPageConstants: ibHeaderMainPageNameSpace.ibHeaderMainPageConstants,
        private $rootScope: CommonsRootScope,
        private $filter: angular.IFilterService,
        private CommonsUserUtilsService: CommonsUserUtilsService
    ) { }

    initializeMainPageHeader = (): ibHeaderMainPage.MainInfo => {
        const lenguageList: Array<ibHeaderMainPage.lenguageList> = this.ibHeaderMainPageConstants.languagesWcs[this.$rootScope.appMarket.toLowerCase()];
        const marketList: Array<ibHeaderMainPage.marketList> = this.ibHeaderMainPageConstants.marketsWcs;
        const loggedInfo: ibHeaderMainPage.loggedInfo = this.getCustomerData();
        this.viewInfo = {
            customerData: loggedInfo.customerData,
            languages: lenguageList,
            markets: marketList,
            selectedLanguage: this.$filter('filter')(lenguageList, ((lenguageList: ibHeaderMainPage.lenguageList): boolean => { return lenguageList.code === this.$rootScope.appLang; }))[0],
            selectedMarket:this.$filter('filter')(marketList, ((marketsList:ibHeaderMainPage.marketList): boolean => { return marketsList.code === this.$rootScope.appMarket; }))[0],
            marketLabel: this.$filter('filter')(this.ibHeaderMainPageConstants.marketsWcs, ((marketsList): boolean => { return marketsList.code === this.$rootScope.appMarket; }))[0].description,
            logged: loggedInfo.isLogged
        };
        return this.viewInfo;
    };

    private getCustomerData = (): ibHeaderMainPage.loggedInfo => {
        const CustomerInfo: any = this.localStorageService.get('customerData');
        const isIbZero = this.CommonsUserUtilsService.isIbZero();
        const isSoftUser = this.CommonsUserUtilsService.isSoftUser();
        let response: ibHeaderMainPage.loggedInfo = {customerData: null, isLogged: null};
        if (CustomerInfo) {
            const surname = isSoftUser ? '' : CustomerInfo.personalInfo.surname1;
            response = {
                customerData: {
                    name: `${CustomerInfo.personalInfo.name || CustomerInfo.personalInfo.contactEmail} ${surname}`.trim(),
                    avios: !isIbZero ? CustomerInfo.generalInfo.aviosTransformed : null
                },
                isLogged: true
            };
        }
        return response;
    };
}
